import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  extendVersionApiCrud,
  type ExtendVersionRequest,
} from "@/generated/fastapi";

export async function extendVersion(
  accessToken: string | null | undefined,
  request: ExtendVersionRequest,
) {
  const response = await extendVersionApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to extend version (${response.status})`);
  }

  return response.data;
}
